import {
  AUTHENTICATE_PARDOT_REQUEST, AUTHTENTICATING_PARDOT_SUCCEEDED, AUTHTENTICATING_PARDOT_FAILED,
  UPDATE_PARDOT_REQUEST, UPDATING_PARDOT_SUCCEEDED, UPDATING_PARDOT_FAILED,
  FETCHING_PARDOT_FORMS_SUCCEEDED, FETCHING_PARDOT_FORMS_FAILED, SELECT_PARDOT_FORM,
  FETCH_PARDOT_FORMS
} from 'constants/actionTypes';

import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import { call, put, takeEvery } from 'redux-saga/effects';

const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
const PARDOT_BASE_URL = `${apiUrl}/integrations/pardot`;

/*
* Authenticate Pardot
*/
export const authenticatePardot = createAction(AUTHENTICATE_PARDOT_REQUEST, (code, callback) => {
  return {
    code: code,
    callback: callback
  }
})

const authenticatePardotSucceeded = createAction(AUTHTENTICATING_PARDOT_SUCCEEDED, (response) => {
  return response;
})

const authenticatePardotFailed = createAction(AUTHTENTICATING_PARDOT_FAILED, (error) => {
  return error;
})

function* authenticatePardotSaga(action) {
  const { code, callback } = action.payload;

  let params = {
    code: code
  }

  let url = buildUrl(PARDOT_BASE_URL, {
    queryParams: params
  });

  const authenticatePardotAPI = () => {
    return axios.post(url).then(response => response.data);
  }

  try {
    const response = yield call(authenticatePardotAPI);
    if (response) {
      yield put(authenticatePardotSucceeded(response));
    }
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(authenticatePardotFailed(error));
  }
}

/*
* Update Pardot
*/
export const updatePardot = createAction(UPDATE_PARDOT_REQUEST, (request, callback) => {
  return {
    request: request,
    callback: callback
  };
})

export const updatingPardotSucceeded = createAction(UPDATING_PARDOT_SUCCEEDED, (response) => {
  return response;
})

export const updatingPardotFailed = createAction(UPDATING_PARDOT_FAILED, (error) => {
  return error;
})

function* updatePardotSaga(action) {
  const { request, callback } = action.payload;

  const updatePardotAPI = () => {
    return axios.put(PARDOT_BASE_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(updatePardotAPI);
    if (response) {
      yield put(updatingPardotSucceeded(response));
    }
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(updatingPardotFailed(error));
  }
}

/*
* Fetching pardot form
*/

export const fetchPardotForms = createAction(FETCH_PARDOT_FORMS, request => {
  return request;
});

const fetchingPardotFormsSucceeded = createAction(FETCHING_PARDOT_FORMS_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  }
});

const fetchingPardotFormsFailed = createAction(FETCHING_PARDOT_FORMS_FAILED, error => {
  return error;
})

function* fetchPardotFormSaga(action) {

  const request = action.payload;

  const fetchPardotFormsAPI = () => {
    return axios.post(`${PARDOT_BASE_URL}/forms`, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchPardotFormsAPI);
    if (response) {
      yield put(fetchingPardotFormsSucceeded(request, response));
    }
  } catch (error) {
    yield put(fetchingPardotFormsFailed(error));
  }
}

/**
 * Select Marketo Form
 */
export const selectPardotForm = createAction(SELECT_PARDOT_FORM, (form) => {
  return form;
})

export default function* pardotSaga() {
  yield takeEvery(AUTHENTICATE_PARDOT_REQUEST, authenticatePardotSaga);
  yield takeEvery(UPDATE_PARDOT_REQUEST, updatePardotSaga);
  yield takeEvery(FETCH_PARDOT_FORMS, fetchPardotFormSaga)
}